/**
 * NOTE: This function is copied over from `webapp-ng/src/heatmap/js/controllers/heatmap-report-base.js` with some minor
 * changes, to not rely on variables outside the scope.
 *
 * Function to group the logic that goes through the entire screenshot's height to add lines in HTML or Canvas
 * @param height Page height
 * @param scrollReach the heatmap data scrollReach value
 */
export const processScrollMarkers = (
  height: number,
  scrollReach: number[],
): { top: number; value: string }[] => {
  const scrollReachFixedMarkers = [];

  let scrollReachTargetValue = 75;
  let scrollReachIndex;
  let scrollReachValue;
  let y;

  for (y = 0; y <= height; y += 1) {
    scrollReachIndex = Math.round((y * 1000) / height);
    scrollReachValue = scrollReach[scrollReachIndex] / 10;

    if (scrollReachValue <= scrollReachTargetValue && scrollReachValue > 0) {
      scrollReachFixedMarkers.push({
        top: (y * 100) / height,
        value: `${scrollReachTargetValue.toFixed(0)}%`,
      });

      scrollReachTargetValue -= 25;
    }
  }

  return scrollReachFixedMarkers;
};
